import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyAdu9Vu5dEQ27NSoE6zpNaiC-JSYZzIjtA",
  authDomain: "stop-the-spread-c5bac.firebaseapp.com",
  databaseURL: "https://stop-the-spread-c5bac.firebaseio.com",
  projectId: "stop-the-spread-c5bac",
  storageBucket: "stop-the-spread-c5bac.appspot.com",
  messagingSenderId: "722879080732",
  appId: "1:722879080732:web:9648bfda2508786070b2d9"
};
// Initialize firebase
const firebaseApp = firebase.initializeApp(firebaseConfig);

const messaging = firebase.messaging();
// Add the public key generated from the console here.
messaging.usePublicVapidKey("BCka0ps__W5Wp8MVZ4qEW1LSlfqjfwnK4Mn7p4ilVXayCrpUEsQDX2m9VNN0Hq3NtnuJ19GA0TnA1YOMT6LEV2U");
// Get Instance ID token. Initially this makes a network call, once retrieved
// subsequent calls to getToken will return from cache.
messaging.onTokenRefresh(() => {
  messaging.getToken().then((refreshedToken) => {
    console.log('Token refreshed.');
    // Indicate that the new Instance ID token has not yet been sent to the
    // app server.
    // eslint-disable-next-line no-undef
    setTokenSentToServer(false);
    // Send Instance ID token to app server.
    // eslint-disable-next-line no-undef
    sendTokenToServer(refreshedToken);
    // ...
  }).catch((err) => {
    console.log('Unable to retrieve refreshed token ', err);
    // eslint-disable-next-line no-undef
    showToken('Unable to retrieve refreshed token ', err);
  });
});

export default firebaseApp.firestore();

messaging.onMessage(payload => {
  console.log('onMessage', payload);
});
